import { render, staticRenderFns } from "./uploadWXGroup.vue?vue&type=template&id=564052f0&"
import script from "./uploadWXGroup.vue?vue&type=script&lang=js&"
export * from "./uploadWXGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports